type RentSetupBannerProps = {
  onSetup: () => void;
};

export const RentSetupBanner = ({ onSetup }: RentSetupBannerProps) => (
  <div className='rent-setup-banner'>
    <div className='rent-setup-banner-inner'>
      <div className='rent-setup-banner-glow' aria-hidden='true' />
      <div className='rent-setup-banner-shimmer' aria-hidden='true' />
      <div className='rent-setup-banner-body'>
        <div className='rent-setup-banner-copy'>
          <h2 className='rent-setup-banner-title'>Ready to settle your rent?</h2>
          <p className='rent-setup-banner-sub'>
            Add your property and pay this month&apos;s rent in just a few steps. Stay on track and
            start earning rewards.
          </p>
        </div>
        <button type='button' className='rent-setup-banner-btn' onClick={onSetup}>
          Pay rent now
        </button>
      </div>
    </div>
  </div>
);
